<ng-template    #actionsTemplate let-element="element">
    <ss-process-action-template [process]="element" (actionCompleted)="actionCompleted($event)"></ss-process-action-template>
</ng-template>


<ng-template ssMobileToolbarContent>
    <div class="flex-row flex--justify-between flex--align-center flex-1">
        <h5 class="mat-headline-5 primary-contrast-text">{{titleObs | async | translate}}</h5>
        <button
            mat-icon-button
            (click)="showSearchSubject.next(!showSearchSubject.value)"
        >
            <mat-icon class="primary-contrast-text">search</mat-icon>
        </button>
    </div>
    
</ng-template>

<ng-template #toolbarTemplate>
    <button  *ngIf="isCreator && (isLargeScreenObs | async)" mat-raised-button color="primary" (click)="routeToWizard()"><mat-icon>add</mat-icon>{{'ss-entities.process.new' | translate}}</button>
</ng-template>


<ss-data-grid   #gridRef
                class="display-block full-height"
                [showSearch]="showSearchSubject | async"
                [columns]="columnsSubject | async" 
                [gridTitle]="titleObs | async"
                [loadFn]="loadObs | async" 
                (rowClick)="routeToDetail($event)" 
                [actionsTemplate]="actionsTemplate"
                [getRowLoaderKeys]="getRowLoaderKeys"
                [updateDataFn]="updateDataFn"
                [toolbarTemplate]="(isCreator && (isLargeScreenObs | async)) ? toolbarTemplate : null"
>
    
</ss-data-grid>
